<template>
    <div class="page-section">
        <company-view-heading v-bind="{ company }" isLinkEnabled>
            <template #actions> <slot name="actions" /> </template>
        </company-view-heading>
        <v-divider class="border-2 primary my-16 my-lg-20" />
        <company-view-introduction-images v-bind="introduction" class="mb-16 mb-lg-20"/>
        <company-view-introduction-content v-bind="introduction" />
    </div>
</template>

<script>
import CompanyViewHeading from "@/components/client/companies/view/company-view-heading.vue";
import CompanyViewIntroductionImages from "@/components/client/companies/view/company-view-introduction-images.vue";
import CompanyViewIntroductionContent from "@/components/client/companies/view/company-view-introduction-content.vue";

export default {
    components: {
        CompanyViewHeading,
        CompanyViewIntroductionImages,
        CompanyViewIntroductionContent,
    },
    props: {
        company: { type: Object, default: () => ({}) },
    },
    computed: {
        introduction() {
            return this.company?.introduction;
        },
    },
};
</script>